module.exports = __webpack_public_path__ + "img/bg-people.ce934eaa.svg";